module.exports = __webpack_public_path__ + "media/images/application/template/logo-leviat-04b5f03415fcbce0b54480bba5e59863.svg";